import React from 'react';
import { AppTokenConsumer } from '../contexts/AppTokenContext';
//components
import SearchPage from './searchPage/SearchPage';

export default function HomePage() {
  return (
    <>
      <AppTokenConsumer>
        {
          (tokenObj) => {
            return <SearchPage authToken={tokenObj?.accessToken} />
          }
        }
      </AppTokenConsumer>
    </>
  );
}
